import { jsx as o, jsxs as p } from "react/jsx-runtime";
import { withManagedProps as m } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import { toastBlueprint as u } from "./index-blueprint.es.js";
import { toast as T, Toaster as h } from "sonner";
import { useTranslate as g } from "@made-people/grease-translations";
import { StatusSuccessIcon as b, StatusErrorIcon as N } from "@made-people/blueprint-icons";
import "@made-people/blueprint";
const v = u.get(), w = Object.keys(v.variants.type), _ = t.object({
  variants: t.custom().optional(),
  children: t.custom().optional(),
  title: t.string().or(t.literal(!1)).optional(),
  description: t.string().optional(),
  dismissible: t.boolean().optional(),
  id: t.string().or(t.number()).optional(),
  className: t.string().optional(),
  type: t.enum(w).optional(),
  icons: t.object({
    success: t.custom().optional(),
    error: t.custom().optional(),
    warning: t.custom().optional()
  }).optional()
}), j = m(
  "Toast",
  y(
    {
      schema: _,
      defaultProps: {
        variants: {
          type: "info"
        },
        icons: {
          success: /* @__PURE__ */ o(b, {}),
          error: /* @__PURE__ */ o(N, {})
        }
      }
    },
    ({
      variants: e,
      className: i,
      children: n,
      title: a,
      description: l,
      type: d,
      dismissible: S,
      icons: r,
      id: x
    }) => {
      const s = u.styles(e), f = g(), c = {
        success: r == null ? void 0 : r.success,
        error: r == null ? void 0 : r.error,
        warning: r == null ? void 0 : r.warning
      }[d];
      return /* @__PURE__ */ o("div", { className: s.wrapper, children: /* @__PURE__ */ o("div", { className: s.container, children: /* @__PURE__ */ p("div", { className: s.content, children: [
        a && /* @__PURE__ */ p("p", { className: s.title, children: [
          c && /* @__PURE__ */ o("span", { className: s.icon, children: c }),
          f(a)
        ] }),
        l && /* @__PURE__ */ o("p", { className: s.description, children: l })
      ] }) }) });
    }
  )
);
function W(e) {
  let i;
  e.type === "error" ? i = "Toast_Error_Title" : e.type === "success" ? i = "Toast_Success_Title" : e.type === "warning" && (i = "Toast_Warning_Title");
  const n = (e == null ? void 0 : e.title) || i;
  return T.custom((a) => /* @__PURE__ */ o(
    j,
    {
      id: a,
      title: e.title ?? n,
      description: e.description,
      type: e.type,
      variants: {
        type: e.type ? { initial: e.type } : "info"
      }
    }
  ));
}
const Z = m("Toaster", () => /* @__PURE__ */ o(h, { position: "top-right" }));
export {
  j as Toast,
  Z as Toaster,
  W as toast,
  _ as toastSchema
};
//# sourceMappingURL=index.es.js.map
